import { createContext, useContext } from 'react';

export const Auth0ConfigurationContext = createContext(false);

export function useIsAuth0Configured() {
  return useContext(Auth0ConfigurationContext);
}
